import ProviderFilter from '@UI/Pages/Administration/AiEngines/Sections/ModelsSection/Filters/ProviderFilter';
import SearchFilter from '@UI/Pages/Administration/AiEngines/Sections/ModelsSection/Filters/SearchFilter';
import * as React from 'react';
import { Grid, GridItem } from '@verclam/grid-system';
import { useSelector } from '@verclam/synapse';

/**
 * Writes into `aiModelFiltersSignal` through its leaf filters; never receives the filter state as a
 * prop. Both filters are applied client-side. The provider options come from the store, so a provider
 * with no model yet stays selectable.
 */
const Filters: React.FC = () => {
	const providers = useSelector((state) => state.aiConfigurationStore.providers);

	const providerOptions = React.useMemo(
		() =>
			(providers?.list ?? [])
				.map((provider) => ({ id: provider.id, label: provider.label }))
				.sort((left, right) => left.label.localeCompare(right.label, 'fr')),
		[providers],
	);

	return (
		<Grid columns={8} columnGap={1} rowGap={1} alignItems="end">
			<GridItem columnSize={{ xl: 4, lg: 4, md: 5, sm: 8, xs: 8 }}>
				<SearchFilter />
			</GridItem>
			<GridItem columnSize={{ xl: 3, lg: 3, md: 3, sm: 8, xs: 8 }}>
				<ProviderFilter options={providerOptions} />
			</GridItem>
		</Grid>
	);
};

export default Filters;
